
  export const style = {
    api: {
      apiProduction: "https://clubecasaacademy.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: null,
      nameProfile: "clubecasa",
      hostHeader: "clubecasa",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.amazonaws.com/Logos/primary_logo_client_clubecasa.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.amazonaws.com/Logos/secondary_logo_client_clubecasa.png",
      browserLogo: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/favicon_clubecasa.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.amazonaws.com/Logos/primary_logo_client_clubecasa.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "Club&Casa Academy",
      nameScore: "Clubs",
      nameStore: "Resgate Academy",
      nameAcademy: localStorage.getItem("nameAcademy") || "Cursos",
      nameTeam: localStorage.getItem("nameTeam") || "Time",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Conecta",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#000000",
      secondaryColor: localStorage.getItem("secondaryColor") || "#000000",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: false,
      externalUse: false,
      customClient: true,
      customMenuItem: true,
      autoRegister: false,
      recaptchaVersion: "V2",
      showBirthday: "false"
    },
  };
